module.exports = __webpack_public_path__ + "static/media/metacritic.eb3e125e.png";